import { IAssignment } from '@medely/types';
import { Box, Icon, Text } from '@medely/ui-kit';
import { JobDetailsListItem } from '@mp/components/jobs';
import React from 'react';
import { displayParking } from '../utils';

export const AssignmentAdditionalDetailsInfoIcons = ({
  assignment,
  smallIcon = false,
}: {
  assignment: IAssignment;
  smallIcon?: boolean;
}) => {
  const parking = displayParking(assignment);

  return (
    <Box mb={5} testId="additional-details-group">
      <Box pb={2}>
        {!!assignment.min_years_of_experience && (
          <JobDetailsListItem
            icon={
              <Icon
                name="light-briefcase-medical"
                iconSize={smallIcon ? '14px' : '20px'}
                color="text.primary"
                variant="custom"
              />
            }
          >
            <Text size="l">{`${assignment.min_years_of_experience} year${
              assignment.min_years_of_experience > 1 ? 's' : ''
            } of experience required`}</Text>
          </JobDetailsListItem>
        )}
      </Box>

      <Box pb={2}>
        <JobDetailsListItem
          icon={
            <Icon
              name="light-parking-circle"
              iconSize={smallIcon ? '14px' : '20px'}
              color="text.primary"
              variant="custom"
            />
          }
        >
          <Text size="l">{parking}</Text>
          <Text size="m" color="text.secondary" testId="assignment-parking-instructions">
            {assignment.primary_location.parking_instructions}
          </Text>
        </JobDetailsListItem>
      </Box>

      <JobDetailsListItem
        icon={
          <Icon
            name="light-tshirt"
            iconSize={smallIcon ? '14px' : '20px'}
            color="text.primary"
            variant="custom"
          />
        }
      >
        <Text size="l">{`Scrubs are${assignment.scrubs_provided ? ' ' : ' not '}provided`}</Text>
      </JobDetailsListItem>
    </Box>
  );
};
